import fileIcon from '../icons/fileIcon.png'

export const url_pattern =
  /https?:\/\/(www\.)?[a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi

export const us_phone_number = /(1\s?)?[(]?\d{3}[)]?[(\s)?-]\d{3}[\s-]\d{4}/gi

export const ifStringEmpty = text => {
  if (text == null) return true
  text = text.trim()
  return text.length === 0 && !text.trim() && text.trim() !== ' '
}

export const nameValidation = text => {
  if (text == null) return true
  return text.length === 0
}

export function switchAttachmentType(fileType) {
  let type = 'null'
  if (
    fileType.includes([
      'jpeg',
      'png',
      'jpg',
      'jfif',
      'tiff',
      'gif',
      'bmp',
      'webp',
      'svg',
      'pnm',
    ])
  )
    type = 'image'
  else if (fileType.includes('pdf')) type = 'pdf'
  else if (
    fileType.includes([
      'avi',
      'mp4',
      'webm',
      'mkv',
      'flv',
      'vob',
      'm4p',
      '3gp',
      '3g2',
      'mpg',
      'mpeg',
    ])
  )
    type = 'video'
  else if (fileType.includes(['mp3', 'midi'])) type = 'audio'
  return type
}

export function handleIE() {
  return (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    !!document.documentMode === true
  ) //IF IE > 10
}

export function generatePostBackObject(object) {
  return {
    type: 'postback',
    postback: {
      payload: object.payload,
      title: object.title,
    }
  }
}

export const zoomImage = (url, isFullScreen, parentURL) => {
  window.parent.postMessage(
    {
      imageUrl: url,
      isFullScreenWidget: isFullScreen,
    },
    parentURL,
  )
}

export function loadImage(url) {
  return new Promise(resolve => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.src = url
  })
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (const element of vars) {
    const pair = element.split('=')
    if (pair[0] === variable) {
      return decodeURI(pair[1])
    }
  }
  return false
}

export const isElementTop = el => el && !el.scrollTop

export function movePunctualSymbols(text) {
  let copyText = text
  text.split('').forEach(() => {
    if (
      [
        '!',
        '@',
        '#',
        '$',
        '%',
        '^',
        '&',
        '*',
        '(',
        ')',
        '+',
        '=',
        '|',
        '/',
        '/',
        '.',
        '،',
        '>',
        '<',
      ].includes(copyText[copyText.length - 1])
    ) {
      copyText = copyText[copyText.length - 1] + copyText.slice(0, -1)
    }
  })
  return copyText
}

/* eslint-disable */

export function dataURLtoFile(dataUrl, filename) {
  let arr = dataUrl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bStr = atob(arr[1]),
    n = bStr.length,
    u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bStr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

/* eslint-enable */

export function resizeImage(file) {
  return new Promise((resolve, reject) => {
    if (window.File && window.FileReader && window.FileList && window.Blob) {
      if (file) {
        resolve(file)
      }
    }
  })
}

export function getImageUrl(file) {
  return new Promise((resolve, reject) => {
    if (file) {
      resolve(fileIcon)
    }
  })
}

export function getRandomId() {
  return new Date().getTime()
}
